import React from 'react';
import { DarkMode, LightMode } from '@mui/icons-material';
import { Switch, ToggleButton } from '@mui/material';
import { useConsumeWeaveTheme, useWeaveContext, useWeaveThemeConsumer, } from './WeaveContext';
import { WeaveTheme } from './weave.types';
import { StyledToggleButtonGroup } from './WeavePicker.styles';
export default function WeavePicker() {
    const { hasWeaveFlag } = useConsumeWeaveTheme();
    const { isWeaveActive, setIsWeaveActive } = useWeaveThemeConsumer();
    const { setTheme, theme } = useWeaveContext();
    const [localTheme, setLocalTheme] = React.useState(theme);
    const [isAutoTheme, setIsAutoTheme] = React.useState(false);
    const detectThemeEvent = () => {
        window
            .matchMedia('(prefers-color-scheme: dark)')
            .addEventListener('change', event => {
            const newTheme = event.matches
                ? WeaveTheme.Dark
                : WeaveTheme.Light;
            if (isAutoTheme)
                setTheme(newTheme);
            detectThemeEvent();
        });
    };
    React.useEffect(() => {
        if (localTheme === 'auto')
            detectThemeEvent();
        return () => removeEventListener('change', detectThemeEvent);
    }, [theme, isAutoTheme]);
    if (!hasWeaveFlag)
        return React.createElement(React.Fragment, null);
    const handleThemeChange = (event, newTheme) => {
        setLocalTheme(newTheme);
        if (newTheme === 'auto') {
            setIsAutoTheme(true);
            detectThemeEvent();
            // change to the actual theme
            if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
                return setTheme(WeaveTheme.Dark);
            }
            return setTheme(WeaveTheme.Light);
        }
        else {
            setIsAutoTheme(false);
        }
        if (newTheme !== null)
            setTheme(newTheme);
    };
    return (React.createElement("div", { style: {
            display: 'flex',
            gap: '1rem',
            alignItems: 'center',
            padding: '0 1rem',
        } },
        React.createElement(Switch, { checked: isWeaveActive, onChange: () => setIsWeaveActive(!isWeaveActive) }),
        React.createElement(StyledToggleButtonGroup, { value: localTheme, color: "secondary", exclusive: true, onChange: handleThemeChange, "aria-label": "text alignment" },
            React.createElement(ToggleButton, { value: "auto", "aria-label": "auto theme", selected: localTheme === 'auto', disabled: !isWeaveActive }, "Auto"),
            React.createElement(ToggleButton, { value: WeaveTheme.Light, "aria-label": "light theme", selected: localTheme === WeaveTheme.Light, disabled: !isWeaveActive },
                React.createElement(LightMode, null)),
            React.createElement(ToggleButton, { value: WeaveTheme.Dark, "aria-label": "dark theme", selected: localTheme === WeaveTheme.Dark, disabled: !isWeaveActive },
                React.createElement(DarkMode, null)))));
}
